import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { contextService } from "@/domain/services/contextService";
import { ROUTES } from "@/domain/constants/routes";

/**
 * 智能路由組件
 * 根據用戶狀態導向到適當的頁面
 */
export function SmartRouter({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  const skipCheckList = [
    ROUTES.HOME,
    ROUTES.LOGIN,
    ROUTES.TERMS,
    ROUTES.PRIVACY,
    ROUTES.NOT_FOUND,
  ];

  useEffect(() => {
    const path = location.pathname;
    // 如果用戶不在 HOME 頁面，不需要重定向
    if (skipCheckList.includes(path)) {
      setIsChecking(false);
      return;
    }

    const checkUserContext = async () => {
      const userContext = await contextService.getContext();
      if (!userContext.hasOwnProperty("current_page_id")) {
        if (path !== ROUTES.LOGIN) {
          navigate(ROUTES.LOGIN, { replace: true });
        }
      } else if (!userContext.current_page_id && userContext.is_new_user) {
        navigate(ROUTES.ACCOUNT_INIT, { replace: true });
      } else if (userContext.is_new_user) {
        if (
          ![ROUTES.CONVERSATION, ROUTES.AGENTS, ROUTES.LOGIN].includes(path)
        ) {
          navigate(ROUTES.CONVERSATION, { replace: true });
        }
      } else {
        if (path !== ROUTES.AGENTS) {
          navigate(ROUTES.AGENTS, { replace: true });
        }
      }
      setIsChecking(false);
    };
    checkUserContext();
  }, [navigate, location.pathname]);

  // 在檢查過程中顯示載入中狀態
  if (isChecking) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-pulse text-gray-700 dark:text-gray-300">
          載入中...
        </div>
      </div>
    );
  }

  // 檢查完成後，顯示子組件
  return children;
}
